import { render, staticRenderFns } from "./AddAc.vue?vue&type=template&id=72bc1b2c&"
import script from "./AddAc.vue?vue&type=script&lang=js&"
export * from "./AddAc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports